import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, FileCheck, Eye, Download, Clock, CheckCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Privacy() {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="privacy-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Privacy e GDPR</h1>
        <p className="text-slate-500 mt-1">Gestione consensi e conformità normativa</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-green-50 rounded-lg">
                <CheckCircle className="h-5 w-5 text-green-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-green-600">0</p>
                <p className="text-xs text-slate-500">Consensi Attivi</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-yellow-50 rounded-lg">
                <Clock className="h-5 w-5 text-yellow-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-yellow-600">0</p>
                <p className="text-xs text-slate-500">In Scadenza</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-red-50 rounded-lg">
                <Shield className="h-5 w-5 text-red-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-red-600">0</p>
                <p className="text-xs text-slate-500">Revocati</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-lg">
                <Eye className="h-5 w-5 text-blue-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-blue-600">0</p>
                <p className="text-xs text-slate-500">Accessi Log</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Consensi */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <FileCheck className="h-5 w-5 text-green-600" />
              Gestione Consensi
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Gestisci i consensi al trattamento dei dati personali raccolti secondo il GDPR.
              </p>
              <div className="space-y-2">
                <Button variant="outline" className="w-full justify-start" data-testid="btn-nuovo-consenso">
                  <FileCheck className="h-4 w-4 mr-2" />
                  Registra Nuovo Consenso
                </Button>
                <Button variant="outline" className="w-full justify-start" data-testid="btn-revoca-consenso">
                  <Shield className="h-4 w-4 mr-2" />
                  Revoca Consenso
                </Button>
                <Button variant="outline" className="w-full justify-start" data-testid="btn-esporta-consensi">
                  <Download className="h-4 w-4 mr-2" />
                  Esporta Consensi
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Log Accessi */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Eye className="h-5 w-5 text-blue-600" />
              Log Accessi Dati
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Registro degli accessi ai dati personali per conformità GDPR.
              </p>
              <div className="space-y-2 text-center py-8 text-slate-500">
                <Eye className="h-8 w-8 mx-auto opacity-50" />
                <p className="text-sm">Nessun accesso registrato</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Informativa */}
      <Card>
        <CardHeader>
          <CardTitle>Informativa Privacy</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="prose prose-sm max-w-none">
            <p className="text-slate-600">
              I dati personali raccolti sono trattati in conformità al Regolamento UE 2016/679 (GDPR) 
              e alla normativa italiana in materia di protezione dei dati personali.
            </p>
            <div className="mt-4 p-4 bg-slate-50 rounded-lg">
              <h4 className="font-semibold text-slate-900 mb-2">Titolare del Trattamento</h4>
              <p className="text-sm text-slate-600">
                Associazione Nazionale Carabinieri - Protezione Civile
              </p>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                <CheckCircle className="h-3 w-3 mr-1" />
                GDPR Compliant
              </Badge>
              <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
                <Shield className="h-3 w-3 mr-1" />
                Dati Crittografati
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
